import { useQuery } from '@tanstack/react-query'

import {
  getAllProductsAvailability,
  type GetAllProductsAvailabilityOptions,
} from '@flecto/api/saas'

type QueryPayload = GetAllProductsAvailabilityOptions & {
  enabled?: boolean
}

export function useQueryGetAllProductsAvailability(options: QueryPayload) {
  return useQuery({
    queryKey: ['QueryGetAllProductsAvailability', options],
    queryFn: async () => await getAllProductsAvailability(options),
    enabled: options?.enabled ?? true,
  })
}
